<script lang="ts">
  import { ordersFor } from '$lib/db/threads';
  import { t } from '$lib/i18n/index.svelte';
  import type { MessageElement } from '$lib/protocol/types';
  import { live } from '$lib/state/live';

  import { goBack } from '../../app/router.svelte';
  import OrderView from '../elements/OrderView.svelte';
  import EmptyState from '../parts/EmptyState.svelte';

  let { accountId }: { accountId: string } = $props();

  // Extracted from the local event stream: successive events carry successive
  // states of the same order, the last one wins. The list people come back to
  // weeks later, without scrolling a conversation.
  const orders = live<MessageElement[]>(() => ordersFor(accountId), []);
</script>

<header class="bar">
  <button class="back" onclick={goBack} aria-label={t('common.back')}>‹</button>
  <h1>{t('orders.title')}</h1>
</header>

{#if $orders.length === 0}
  <EmptyState title={t('orders.title')} body={t('orders.empty')} />
{:else}
  <ul class="list">
    {#each $orders as order, i (i)}
      {#if order.type === 'order'}
        <li><OrderView element={order} /></li>
      {/if}
    {/each}
  </ul>
{/if}

<style>
  .bar {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 10px 12px;
  }
  .back {
    border: 0;
    background: transparent;
    font-size: 28px;
    cursor: pointer;
    color: var(--ink);
    padding: 0 8px;
  }
  h1 {
    margin: 0;
    font-size: 20px;
  }
  .list {
    list-style: none;
    margin: 0;
    padding: 0 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }
  li {
    border: 1px solid var(--line);
    border-radius: var(--radius);
    background: var(--surface);
    padding: 12px;
  }
</style>
